import StoreAiCallContractWorkflowCommonLoader from "../libraries/store-ai-call-contract-workflow-common-loader";

export default {

  list() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByName('search')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_ai_call_contracts'
          form_element.submit()
        })
      })

      Array.from(document.getElementsByClassName('th-sortable')).forEach(el => {
        const form = document.forms[0];
        const order_by_applicated_at = form['order_by_applicated_at'];
        const i = el.firstElementChild;
        const col = el.dataset.thSortableCol;
        el.addEventListener('click', (e) => {
          if(col === 'applicated_at') {
            if(order_by_applicated_at.value === 'desc') {
              order_by_applicated_at.value = 'asc';
            } else {
              order_by_applicated_at.value = 'desc';
            }
          }
          form.submit();
        }, false);
        if(order_by_applicated_at.value === 'desc') {
          i.textContent = 'arrow_drop_down';
        } else {
          i.textContent = 'arrow_drop_up';
        }
      })

    }, false)
  },

  workflowNew() {
    StoreAiCallContractWorkflowCommonLoader()
  },

  workflowCreate() {
    StoreAiCallContractWorkflowCommonLoader()
  },
}
